import React from 'react';
import { Chip } from '@mui/material';
import VillaOutlinedIcon from '@mui/icons-material/VillaOutlined';
import HomeWorkOutlined from '@mui/icons-material/HomeWorkOutlined';
import CastleOutlined from '@mui/icons-material/CastleOutlined';
import SchoolOutlined from '@mui/icons-material/SchoolOutlined';

import VolunteeringIcon from 'assets/icons/volunteering-heart.svg';
import { lightGray, primaryBlue, white } from 'utils/color-styles';
import Img from 'retired/Img';
import Organization, { NonprofitEntityType } from 'entities/organization/model';

const getContent = ({
  type,
  nonprofitEntityType,
  locationObject,
}: Partial<Organization>): [string, JSX.Element] => {
  if (nonprofitEntityType === NonprofitEntityType.memberAssociatedEntity) {
    return ['Other Nonprofit (non 501c3)', <HomeWorkOutlined sx={{ fill: primaryBlue }} />];
  }
  if (nonprofitEntityType === NonprofitEntityType.governmentEntity) {
    return ['Government Entity', <CastleOutlined sx={{ fill: primaryBlue }} />];
  }
  if (nonprofitEntityType === NonprofitEntityType.school) {
    return ['School', <SchoolOutlined sx={{ fill: primaryBlue }} />];
  }
  if (
    type === 'Nonprofit' &&
    (nonprofitEntityType === NonprofitEntityType.nonprofit || locationObject?.countryCode !== 'US')
  ) {
    return ['Nonprofit', <Img src={VolunteeringIcon} />];
  }
  if (type === 'Company') {
    return ['Company', <VillaOutlinedIcon sx={{ fill: primaryBlue }} />];
  }
  return ['Organization', <Img src={VolunteeringIcon} />];
};

export const OrganizationLabel = ({ organization }: { organization: Partial<Organization> }) => {
  const [label, icon] = getContent(organization);

  return (
    <Chip
      variant="outlined"
      style={{
        marginBottom: 4,
        borderColor: lightGray,
        borderRadius: 16,
        background: white,
      }}
      label={label}
      avatar={icon}
    />
  );
};
